import { Box, FormControl, InputLabel, MenuItem, Modal, Select, Typography, useMediaQuery } from "@mui/material";
import React, { useState } from "react";
import classes from "../../styles/talkToPanditModal.module.css";
import Image from "next/legacy/image";
import applogo2 from "@public/logo1.png";
import RFmandal from "@public/assets/icons/RFmandal.svg";
import UtsavTextField from "src/globalModule/components/UtsavTextField";
import { useTranslation } from "react-i18next";
import Paydone from "@public/assets/Lottie/RightPayment.json";
import dynamic from "next/dynamic";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import CopyToClipboard from "react-copy-to-clipboard";
import { CONTACT_NUMBER, PANDIT_AVAILABILITY, WEB_ENGAGE } from "@utils/constants";
import { useRouter } from "next/router";
import { callPandit } from "src/pujaModule/queries/pujas.queries";
import { trackEvent } from "@utils/analytics/event-analytics";
import CallIcon from "@mui/icons-material/Call";
import UtsavSelect from "src/globalModule/components/UtsavSelect";
const Lottie = dynamic(() => import("lottie-react"), {
  ssr: false
});
function TalkToPanditModal({
  openTalkToPanditModal,
  setOpenTalkToPanditModal,
  name_WE,
  panditAvailability,
  panditContact,
  problemsToDiscuss,
  kundaliDosh,
  callbackTimings
}) {
  const {
    t
  } = useTranslation();
  const router = useRouter();
  const bigScreen = useMediaQuery("(min-width:768px)");
  const {
    id,
    eventid
  } = router.query;
  const [contact, setContact] = useState("");
  const [name, setName] = useState("");
  const [problem, setProblem] = useState("");
  const [isKundali, setIsKundali] = useState("");
  const [dosh, setDosh] = useState("");
  const [callbackTime, setCallbackTime] = useState("");
  const [nameError, setNameError] = useState(false);
  const [contactError, setContactError] = useState(false);
  const [problemError, setProblemError] = useState(false);
  const [isKundaliError, setIsKundaliError] = useState(false);
  const [doshError, setDoshError] = useState(false);
  const [callbackTimeError, setCallbackTimeError] = useState(false);
  const [stepNo, setStepNo] = useState(1);
  const [textToCopy, setTextToCopy] = useState(CONTACT_NUMBER.number); // The text you want to copy
  const [copyStatus, setCopyStatus] = useState(false); // To indicate if the text was copied

  const onCopyText = () => {
    setCopyStatus(true);
    setTimeout(() => setCopyStatus(false), 2000); // Reset status after 2 seconds
  };
  const handleNameChange = e => {
    const value = e.target.value;
    const regex1 = /[`~!@#$%^&*()_|+\-=?;:'".,<>\{\}\[\]\\\/0-9]/gi;
    if (regex1.test(value)) {
      return;
    }
    setName(value);
    const regex = /^$|^[a-zA-Z. ]+(([', -][a-zA-Z ])?[a-zA-Z ]*)*$/;
    if (e.target.validity.valid && regex.test(value)) {
      setNameError(false);
    }
  };
  const handleNumberChange = e => {
    let inputValue = e.target.value;
    inputValue = inputValue.replace(/\D/g, "");
    inputValue = inputValue?.replace(/^\+91-/, "")?.replace(/^\+91/, "")?.replace(/^0-/, "")?.replace(/^0/, "")?.replace(" ", "")?.replace("-", "");
    if (e.target.validity.valid && inputValue?.length === 10) {
      setContactError(false);
    }
    if (inputValue?.length > 10) {
      return;
    }
    setContact(inputValue);
  };
  const handleClose = () => {
    setOpenTalkToPanditModal(false);
  };
  const formSubmit = async () => {
    if (name === "") {
      setNameError(true);
      return;
    }
    if (contact === "" || contact.length < 10) {
      setContactError(true);
      return;
    }
    if (problem === "") {
      setProblemError(true);
      return;
    }
    if (isKundali === "") {
      setIsKundaliError(true);
      return;
    }
    if (dosh === "") {
      setDoshError(true);
      return;
    }
    if (callbackTime === "" && panditAvailability !== PANDIT_AVAILABILITY.CALL_PANDIT) {
      setCallbackTimeError(true);
      return;
    }
    if (panditAvailability === PANDIT_AVAILABILITY.CALL_PANDIT) {
      window.location.href = `tel:+91${panditContact}`;
    }
    const res = await callPandit({
      name,
      contact,
      eventLink: `${process.env.NEXT_PUBLIC_APP_HOSTNAME}/puja/${id}/${eventid}`,
      isDirectCall: panditAvailability === PANDIT_AVAILABILITY.CALL_PANDIT,
      problem: problem,
      isKundali: isKundali === "Yes" ? true : false,
      kundaliDosh: dosh,
      callbackTiming: callbackTime
    });
    trackEvent(WEB_ENGAGE.SCREEN_NAMES.EVENT_DETAILS + " " + WEB_ENGAGE.BUTTON_NAMES.PANDIT_FORM_SUBMIT + " " + WEB_ENGAGE.EVENT_NAMES.BUTTON_CLICKED, {
      [WEB_ENGAGE.EVENT_PROPERTIES.SCREEN_NAME]: WEB_ENGAGE.SCREEN_NAMES.EVENT_DETAILS,
      [WEB_ENGAGE.EVENT_PROPERTIES.BUTTON_NAME]: WEB_ENGAGE.BUTTON_NAMES.PANDIT_FORM_SUBMIT,
      [WEB_ENGAGE.EVENT_PROPERTIES.KRIYA_NAME]: name_WE || "Unknown Kriya",
      [WEB_ENGAGE.EVENT_PROPERTIES.EVENT_URL_EXTENSION]: eventid
    });

    // if (panditAvailability === PANDIT_AVAILABILITY.FORM_FILLUP) {
    setStepNo(2);
    //}
  };
  return <Modal open={openTalkToPanditModal} onClose={handleClose} data-sentry-element="Modal" data-sentry-component="TalkToPanditModal" data-sentry-source-file="talkToPanditModal.jsx">
      <Box className={classes.modalContainer} data-sentry-element="Box" data-sentry-source-file="talkToPanditModal.jsx">
        {/* <div className={classes.modalCard}> */}
        <div className={classes.modalTop}>
          <Box data-sentry-element="Box" data-sentry-source-file="talkToPanditModal.jsx">
            <div className={classes.modalHeader}>
              <div className={classes.logo}>
                <Image src={applogo2} alt="applogo"
              // height={15}
              // width={40}
              data-sentry-element="Image" data-sentry-source-file="talkToPanditModal.jsx" />
              </div>
              <Typography className={classes.utsavFont} data-sentry-element="Typography" data-sentry-source-file="talkToPanditModal.jsx">Utsav</Typography>
            </div>
          </Box>
          <div className={classes.mandalaContainer}>
            <RFmandal data-sentry-element="RFmandal" data-sentry-source-file="talkToPanditModal.jsx" />
          </div>
        </div>

        {/* {!bigScreen || !isPanditJiAvailable ? ( */}
        <div className={classes.detailsForm}>
          {stepNo === 1 ? <>
              <Typography className={classes.registrationDetailsHeader}>
                {t("enter-your-name-and-number")}
              </Typography>
              <UtsavTextField id="outlined-basic" label={t("enter-your-name")} name="Name" type="text" varient="outlined" value={name} autoComplete="name" setProps={handleNameChange} // setProps
          error={nameError} important={true} />
              <UtsavTextField label={t("enter-phone-number")} name="Contact" type="tel" value={contact} autoComplete="tel" inputProps={{
            inputMode: "numeric",
            pattern: "[0-9]*"
          }} setProps={handleNumberChange} // setProps
          startAdornment={"+91"} error={contactError} important={true} />

              <UtsavSelect label="Problems you would like to discuss?" value={problem} onChange={e => {
            setProblem(e.target.value);
            setProblemError(false);
          }} options={problemsToDiscuss} error={problemError} errorMessage="Please select your problem" />

              <UtsavSelect label="Do you have your Kundali Made?" value={isKundali} onChange={e => {
            setIsKundali(e.target.value);
            setIsKundaliError(false);
          }} options={["Yes", "No"]} error={isKundaliError} errorMessage="Please select yes/no" />

              <UtsavSelect label={"Do you have any Kundali Dosh?"} value={dosh} onChange={e => {
            setDosh(e.target.value);
            setDoshError(false);
          }} options={kundaliDosh} error={doshError} errorMessage="Please select your kundali dosh." />

              {panditAvailability !== PANDIT_AVAILABILITY.CALL_PANDIT && <>
                  <UtsavSelect label={"Preferred Callback time?"} value={callbackTime} onChange={e => {
              setCallbackTime(e.target.value);
              setCallbackTimeError(false);
            }} options={callbackTimings} error={callbackTimeError} errorMessage="Please select your callback time." />
                </>}

              {/* {panditAvailability === PANDIT_AVAILABILITY.CALL_PANDIT ? (
                <button
                  className={classes.talkToPanditBtn}
                  onClick={formSubmit}
                >
                  <CallIcon />
                   <Typography
                    fontFamily={"Poppins"}
                    fontSize={"18px"}
                    color={"#ffffff"}
                    fontWeight={600}
                  >
                    Call Panditji
                  </Typography>
                </button>
               ) : ( */}
              <button className={classes.talkToPanditBtn} onClick={formSubmit}>
                {panditAvailability === PANDIT_AVAILABILITY.CALL_PANDIT ? <>
                    <CallIcon />
                    <Typography fontFamily={"Poppins"} fontSize={"18px"} color={"#ffffff"} fontWeight={600}>
                      Call Panditji
                    </Typography>
                  </> : <Typography fontFamily={"Poppins"} fontSize={"18px"} color={"#ffffff"} fontWeight={600}>
                    Submit Details
                  </Typography>}
              </button>
              {/* )} */}
            </> : <>
              <div className={classes.lottieDiv}>
                {" "}
                <Lottie animationData={Paydone} loop={true} className={classes.boxLottieAnime} />
              </div>
              <Typography className={classes.confirmMsg}>
                Your details submitted successfully.
              </Typography>
              {panditAvailability === PANDIT_AVAILABILITY.FORM_FILLUP && <Typography className={classes.bottomMsg}>
                  Our panditji will contact you soon.
                </Typography>}
            </>}
        </div>
        {/* ) : (
          <div className={classes.desktopVersion}>
            <Typography sx={{ fontSize: "18px", fontWeight: "bold" }}>
              Our panditji support number:
            </Typography>
            <div className={classes.contactContainer}>
              <Typography className={classes.contact}>
                +91 {CONTACT_NUMBER.number}
              </Typography>
              <div className={classes.copyBtn}>
                <CopyToClipboard text={textToCopy} onCopy={onCopyText}>
                  <ContentCopyIcon />
                </CopyToClipboard>
              </div>
            </div>
            {copyStatus && <Typography>Text copied to clipboard!</Typography>}
          </div>
         )} */}
        {/* </div> */}
      </Box>
    </Modal>;
}
export default TalkToPanditModal;